import { Box, ScrollArea } from '@mantine/core';
import { ReactNode, Ref, RefObject } from 'react';

type Props = {
  children: ReactNode;
  chrome: ReactNode;
  scrollingHeader?: ReactNode;
  containerRef?: Ref<HTMLDivElement>;
  verticalViewportRef?: RefObject<HTMLDivElement | null>;
};

const ScopeNavigatorViewport = ({
  children,
  chrome,
  scrollingHeader,
  containerRef,
  verticalViewportRef,
}: Props) => (
  <Box ref={containerRef} w="100%" h="100%" mih={0}>
    <ScrollArea
      data-scope-vertical-viewport
      scrollbars="y"
      type="auto"
      offsetScrollbars="y"
      w="100%"
      h="100%"
      viewportRef={verticalViewportRef}
    >
      {scrollingHeader}
      <Box
        data-scope-navigator-chrome
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 2,
          background: 'var(--mantine-color-body)',
        }}
      >
        {chrome}
      </Box>
      {children}
    </ScrollArea>
  </Box>
);

export default ScopeNavigatorViewport;
